/* eslint-disable no-unused-vars */
import Swiper from 'swiper/bundle';

const init = () => {
  const testimonialSliders = document.querySelectorAll('.testimonial-slider-wrapper');

  if (testimonialSliders.length === 0) {
    return;
  }

  // Loop and initialize sliders
  testimonialSliders.forEach((sliderWrapper) => {
    const sliderEl = sliderWrapper.querySelector('.testimonial-slider.swiper');
    const paginationElement = sliderWrapper.querySelector('.swiper-pagination');
    const navNextEl = sliderWrapper.querySelector('.swiper-button-next');
    const navPrevEl = sliderWrapper.querySelector('.swiper-button-prev');

    const swiper = new Swiper(sliderEl, {
      autoHeight: true,
      breakpoints: {
        1024: {
          slidesPerView: 2,
          spaceBetween: 140,
        },
      },
      navigation: {
        nextEl: navNextEl,
        prevEl: navPrevEl,
      },
      slidesPerView: 1,
      loop: false,
      autoplay: false,
      pagination: {
        el: paginationElement,
        clickable: true,
      },
    });
  });
};

export default init;
